module.exports = __webpack_public_path__ + "static/media/baloon3.f9c7c7ad.png";